<template>
  <!-- 九州合作服务商-转派订单列表 -->
  <div class="container">
    <div class="handle-box-search">
      <div class="handle-box">
        <el-row class="head-search">
          <el-col :span="12">
            <span class="title">标识:</span>
            <el-input
              v-model="search_data.service_name"
              class="handle-input mr10 service"
              placeholder="请输入标识"
              @keyup.enter.native="searchServiceOrderLists"
            >
            </el-input>
          </el-col>
          <el-col :span="12">
            <span class="title">订单编码:</span>
            <el-input
              v-model="search_data.order_code"
              class="handle-input mr10 service"
              placeholder="请输入名称"
              @keyup.enter.native="searchServiceOrderLists"
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row class="head-search">
          <el-col :span="24">
            <span class="title">乘客电话:</span>
            <el-input
              v-model="search_data.consumer_phone"
              class="handle-input mr10 service"
              placeholder="请输入名称"
              @keyup.enter.native="searchServiceOrderLists"
            >
            </el-input>
          </el-col>
        </el-row>
      </div>
  
      <el-button @click="searchServiceOrderLists" size="medium">搜索</el-button>
      <el-button @click="refresh" size="medium">刷新</el-button>

    </div>

    <el-table
      v-loading="tableLoading"
      :data="tableData"
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
     
    >
     
      <el-table-column label="服务方标识" prop="service_name"> </el-table-column>
      <el-table-column label="名称" prop="title"> </el-table-column>
      <el-table-column label="订单编码" prop="order_code"> </el-table-column>
      <el-table-column label="三方编号" prop="spOrderId"> </el-table-column>
      <el-table-column label="乘客电话" prop="consumer_phone"></el-table-column>
 
      <el-table-column label="接单时间" prop="take_time"></el-table-column>

      <el-table-column label="服务完成时间" prop="end_time"></el-table-column>

      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="订单状态" prop="status"></el-table-column>
      <el-table-column label="城市名称" prop="city_name"></el-table-column>
    


    </el-table>



    <!-- element ui 原生分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="search_data.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result_data.count"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
var _this;


export default {

  data() {
    return {
      detail_isShow: false,
      add_isShow: false,
      bind_isShow: false,
      tableLoading: false,
      service_name_array: [],
      postData: {},
      bindData: {},
      datalist: [],

      // 存放表格数据
      tableData: [],

      //获取用户列表的数据
      search_data: {
        page: 1,
        limit: 10,
        service_name: "",
        order_code: "",
        consumer_phone: "",
      },
      result_data: {},
      search_rules: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;

    _this.searchServiceOrderLists();
  },

  methods: {



    // 刷新按钮
    refresh() {
      this.$router.go(0);
    },
    // 搜索
    searchServiceOrderLists() {
      _this.search_data.page = 1;

      _this.serviceLists();
    },
    // 初始化列表
    serviceLists() {
      _this.tableLoading = true;

      _this
        .$post("/service_order/serviceOrderLists", _this.search_data, _this.search_rules)
        .then((res) => {
          _this.tableLoading = false;

          _this.tableData = res.data;
          _this.result_data = res;
        })
        .catch((err) => {
          _this.tableLoading = false;
          _this.tableData = [];
        });
    },
    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data.limit = val;

      //初始化列表
      _this.serviceLists();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data.page = val;

      //初始化列表
      _this.serviceLists();
    },
    //翻页组件的回调
    pages_function() {
      //初始化列表
      _this.serviceLists();
    },
  },
};
</script>
<style scoped>
.search-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.search-box {
  display: flex;
}

.searchBox {
  margin: 10px;
  padding: 30px 0;
  border-radius: 15px;
  background-color: #f5f7fa !important;
  border: 1px solid #dcdfe6;
}

.title {
  display: inline-block !important;
  width: 80px !important;
  text-align: right !important;
  padding-right: 5px !important;
  box-sizing: border-box !important;
  background-color: transparent !important;
  color: #000;
  font-size: 14px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.btn {
  margin-left: 10px;
}
</style>
<style>
.service .el-input__inner {
  width: 220px;
}
</style>